import React from "react"
import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import { Head } from "components/Head"
import { useTranslation } from "providers/i18n"
import { useGeoLocation } from "providers/geolocation"

export const Layout = () => {
  const { scannedLocations, deviceLocation, locationVenue } = useGeoLocation()
  const { t } = useTranslation()

  return (
    <>
      <Head title={t("Map")} />
      <Box data-name="MapLayout">
        <Outlet
          context={{ scannedLocations, deviceLocation, locationVenue } || {}}
        />
      </Box>
    </>
  )
}
